import React from "react";
import { PiStarFourFill } from "react-icons/pi";

const StarDivider = ({
    lineColor = "#d8a3a3",
    iconColor = "#8b3d3d",
    lineWidth = "40%",
    thickness = "2px",
}) => {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                gap: "3px",
            }}
        >
            <div
                style={{
                    flex: `0 0 ${lineWidth}`,
                    height: thickness,
                    backgroundColor: lineColor,
                }}
            />

            <span
                style={{
                    color: iconColor,
                    fontSize: "18px",
                    fontWeight: 600,
                    lineHeight: 1,
                }}
            >
                <PiStarFourFill />
            </span>

            <div
                style={{
                    flex: `0 0 ${lineWidth}`,
                    height: thickness,
                    backgroundColor: lineColor,
                }}
            />
        </div>
    );
};

export default StarDivider;